import {mediaSizeFit} from '../helper/file';

export default class ImageNodeView {
    constructor(node, view, getPos) {
        const image = document.createElement("img")
        image.src = node.attrs.src;

        if (node.attrs.alt) {
          image.alt = node.attrs.alt;
        }

        if (node.attrs.title) {
          image.title = node.attrs.title;
        }

        if (node.attrs['data-id']) {
          image.setAttribute('data-id', node.attrs['data-id']);
        }

        if (node.attrs.width) {
          image.width = node.attrs.width || image.naturalWidth;
        }

        if (node.attrs.height) {
          image.height = node.attrs.height || image.naturalHeight;
        }

        if (node.attrs['data-diagram']) {
          image.setAttribute('data-diagram', '');
        }

        this.view = view;
        this.getPos = getPos;
        this.dom = image;
        this.attrs = node.attrs;
    }

    createResizeHandle(id, cursor, left, bottom) {
        const handle = document.createElement('div');
        handle.id = id;
        handle.className = 'resize-handle';
        handle.style.cursor = cursor;
        handle.style.left = left + "px";
        handle.style.bottom = bottom + "px";
        return handle;
    }

    selectNode() {
        if (!this.view.editable) {
            return;
        }

        let {top, bottom, left, right} = this.dom.getBoundingClientRect();
        const {left: boxLeft, bottom: boxBottom} = this.view.dom.offsetParent.getBoundingClientRect();

        const handleSize = 10;
        this.nwResize = this.createResizeHandle('nw-resize', 'nwse-resize', left - boxLeft, boxBottom - top - handleSize);
        this.swResize = this.createResizeHandle('sw-resize', 'nesw-resize', left - boxLeft, boxBottom - bottom);
        this.seResize = this.createResizeHandle('se-resize', 'nwse-resize', right - boxLeft - handleSize, boxBottom - bottom);
        this.neResize = this.createResizeHandle('ne-resize', 'nesw-resize', right - boxLeft - handleSize, boxBottom - top - handleSize);

        const resizeHandler = (event) => {
            event.preventDefault();
            const resizeCursor = event.target.id;

            const menu = document.getElementById('menu-tooltip');
            if (menu) {
                menu.remove();
            }

            const {width, height} = this.dom;

            const resize = e => {
                const deltaX = e.clientX - event.clientX;
                const deltaY = e.clientY - event.clientY;

                const {left: boxLeft, bottom: boxBottom, top: boxTop} = this.view.dom.offsetParent.getBoundingClientRect();
                let {top, bottom, left, right} = this.dom.getBoundingClientRect();

                const container = {width, height};
                if (resizeCursor === 'nw-resize') {
                    container.width -= deltaX;
                    container.height -= deltaY;

                    this.nwResize.style.left = left - 3 - boxLeft + "px";
                    this.nwResize.style.bottom = (boxBottom - top - handleSize) + "px";
                    this.swResize && this.swResize.remove();
                    this.seResize && this.seResize.remove();
                    this.neResize && this.neResize.remove();
                } else if (resizeCursor === 'sw-resize') {
                    container.width -= deltaX;
                    container.height += deltaY;

                    this.swResize.style.left = left - 3 - boxLeft + "px";
                    this.swResize.style.bottom = (boxBottom + 4 - bottom - handleSize) + "px";
                    this.nwResize && this.nwResize.remove();
                    this.seResize && this.seResize.remove();
                    this.neResize && this.neResize.remove();
                } else if (resizeCursor === 'se-resize') {
                    container.width += deltaX;
                    container.height += deltaY;

                    this.seResize.style.left = right - boxLeft - handleSize + "px";
                    this.seResize.style.bottom = (boxBottom + 4 - bottom - handleSize) + "px";
                    this.nwResize && this.nwResize.remove();
                    this.swResize && this.swResize.remove();
                    this.neResize && this.neResize.remove();
                } else if (resizeCursor === 'ne-resize') {
                    container.width += deltaX;
                    container.height -= deltaY;

                    this.neResize.style.left = right - boxLeft - handleSize + "px";
                    this.neResize.style.bottom = (boxBottom - top - handleSize) + "px";
                    this.nwResize && this.nwResize.remove();
                    this.swResize && this.swResize.remove();
                    this.seResize && this.seResize.remove();
                }

                const sizeFit = mediaSizeFit(width, height, container.width, container.height);
                this.dom.width = sizeFit.width;
                this.dom.height = sizeFit.height;
                this.dom.style.cursor = event.target.style.cursor;

                let dimensionTooltip = document.getElementById('dimension-tooltip');
                if (!dimensionTooltip) {
                    dimensionTooltip = document.createElement("div");
                    dimensionTooltip.id = "dimension-tooltip";
                    dimensionTooltip.className = 'ui mini popup basic top visible';
                    const dimensionContent = document.createElement("div");
                    dimensionContent.className = 'content';
                    dimensionTooltip.appendChild(dimensionContent)

                    this.view.dom.parentNode.appendChild(dimensionTooltip);
                    this.dimensionTooltip = dimensionTooltip;
                }

                dimensionTooltip.firstElementChild.textContent = `w: ${sizeFit.width}px, h: ${sizeFit.height}px`;
                dimensionTooltip.style.left = e.pageX - boxLeft + 10 + 'px';
                dimensionTooltip.style.top = e.pageY - (boxTop + window.scrollY) + 10 + 'px';
            }

            const stopResize = () => {
                document.removeEventListener('mousemove', resize);
                document.removeEventListener('mouseup', stopResize);

                const dimensionTooltip = document.getElementById('dimension-tooltip');
                if (dimensionTooltip) {
                    dimensionTooltip.remove();
                }

                const state = this.view.state;
                const transaction = state.tr.setNodeMarkup(this.getPos(), undefined, {
                    ...this.attrs,
                    width: this.dom.width,
                    height: this.dom.height
                });
                this.view.dispatch(transaction);
            }

            document.addEventListener('mousemove', resize);
            document.addEventListener('mouseup', stopResize);
        }

        this.nwResize.addEventListener('mousedown', resizeHandler);
        this.swResize.addEventListener('mousedown', resizeHandler);
        this.seResize.addEventListener('mousedown', resizeHandler);
        this.neResize.addEventListener('mousedown', resizeHandler);

        this.view.dom.parentNode.appendChild(this.nwResize);
        this.view.dom.parentNode.appendChild(this.swResize);
        this.view.dom.parentNode.appendChild(this.seResize);
        this.view.dom.parentNode.appendChild(this.neResize);
    }

    deselectNode() {
        if (!this.view.editable) {
            return;
        }

        this.nwResize && this.nwResize.remove();
        this.swResize && this.swResize.remove();
        this.seResize && this.seResize.remove();
        this.neResize && this.neResize.remove();
        this.dimensionTooltip && this.dimensionTooltip.remove();
    }

    destroy() {
        this.deselectNode();
        delete this.dom;
    }
}